import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class SubmenuNavigation {

  constructor() {
    this.$container = $('.submenu-navigation')

    if (this.$container === undefined) {
      return
    }

    this.classes = {
      'submenu': 'submenu-navigation-menu',
      'title': 'submenu-navigation-title',
      'arrowPrev': 'submenu-navigation-prev',
      'arrowNext': 'submenu-navigation-next',
      'activeMobile': 'active-mobile',
      'activeOverlay': 'active-overlay',
      'activeArrow': 'active-arrow'
    }

    this.$window = $(window)
    this.$body = $('body')
    this.$submenuTitle = this.$container.find(`.${this.classes.title}`)
    this.$submenuMenu = this.$container.find(`.${this.classes.submenu}`)
    this.$submenuList = this.$container.find(`ul`)
    this.$submenuArrowPrev = this.$container.find(`.${this.classes.arrowPrev}`)
    this.$submenuArrowNext = this.$container.find(`.${this.classes.arrowNext}`)

    this.handleResize()
    this.submenuCurrent = 0
    this.submenuToScroll = 3

    this.$submenuTitle.on('click', this.handlerClickSubmenuTitle.bind(this))
    this.$submenuArrowPrev.on('click', this.handlerClickArrowPrev.bind(this))
    this.$submenuArrowNext.on('click', this.handlerClickArrowNext.bind(this))

    this.$window.on('load', this.handleScroll.bind(this))
    this.$window.on('resize', this.handleScroll.bind(this))
    this.$window.on('resize', this.handleResize.bind(this))
    this.$window.on('scroll', this.handleScroll.bind(this))
  }

  handleResize() {
    this.widthMenu = this.$submenuMenu.width()
    this.widthList = this.getSumWidthsFor(this.$submenuList.children())
    this.maxWidthList = this.getSumWidthsFor(this.$submenuList.children())
  }

  handlerClickArrowPrev() {
    if (! this.checkActiveSubmenu()) {
      return
    }

    this.submenuCurrent -= this.submenuToScroll

    if (this.submenuCurrent < 0) {
      this.submenuCurrent = 0
    }

    this.refreshPositionList()

    this.$submenuArrowNext.removeAttr('hidden')
  }

  handlerClickArrowNext() {
    if (! this.checkActiveSubmenu()) {
      return
    }

    this.submenuCurrent += this.submenuToScroll

    this.refreshPositionList()

    this.$submenuArrowPrev.removeAttr('hidden')
  }

  handlerClickSubmenuTitle(e) {
    e.preventDefault()
    this.$container.toggleClass(this.classes.activeMobile)
  }

  handleScroll(e) {
    e.preventDefault()

    if (! this.checkActiveSubmenu()) {
      return
    }

    this.widthMenu = this.$submenuMenu.width()
    this.widthList = this.getSumWidthsFor(this.$submenuList.children())

    let $currentElement = this.$submenuList.children().eq(this.submenuCurrent)
    let $nextElements = $currentElement.nextAll()
    let widthNextElements = this.getSumWidthsFor($nextElements.add($currentElement))

    if (this.$submenuList.find('.current-menu-item').length !== 0) {
      this.submenuCurrent = this.$submenuList.find('.current-menu-item').index() -1

      if (this.submenuCurrent < 0) {
        this.submenuCurrent = 0
      }
    }

    if (widthNextElements < this.widthMenu) {
      for (let i = this.submenuCurrent; i < this.$submenuList.children().length && i > 0; i--) {
        let $currentElement = this.$submenuList.children().eq(i)
        let $nextElements = $currentElement.nextAll()
        let widthNextElements = this.getSumWidthsFor($nextElements.add($currentElement))

        if (widthNextElements > this.widthMenu) {
          this.submenuCurrent = i + 1
          break
        }
      }
    }

    this.refreshPositionList()
  }

  refreshPositionList() {
    if (this.maxWidthList < this.widthMenu) {
      this.$submenuArrowNext.attr('hidden', true)
      this.$submenuArrowNext.attr('hidden', true)

      return
    }

    let $currentElement = this.$submenuList.children().eq(this.submenuCurrent)
    let $nextElements = $currentElement.nextAll()
    let widthNextElements = this.getSumWidthsFor($nextElements.add($currentElement))

    // Position
    if (widthNextElements > this.widthMenu) {
      let leftPosition = $currentElement.offset().left - this.$submenuList.offset().left
      this.$submenuList.css('transform', `translateX(-${leftPosition}px)`)
    } else {
      this.$submenuList.css('transform', `translateX(-${this.widthList - this.widthMenu}px)`)
      this.$submenuArrowNext.attr('hidden', true)
    }

    // Controls Prev
    if (this.submenuCurrent === 0) {
      // if first element hidden prev arrow
      this.$submenuArrowPrev.attr('hidden', true)
      this.$submenuArrowPrev.removeClass(this.classes.activeOverlay)
    } else {
      this.$submenuArrowPrev.removeAttr('hidden')
      this.$submenuArrowPrev.addClass(this.classes.activeOverlay)
    }

    // Controls Next
    if (widthNextElements > this.widthMenu) {
      this.$submenuArrowNext.removeAttr('hidden', true)
      this.$submenuArrowPrev.addClass(this.classes.activeOverlay)
    } else {
      this.$submenuArrowNext.removeAttr('hidden')
      this.$submenuArrowNext.attr('hidden', true)
    }
  }

  getSumWidthsFor(elements) {
    let i = 0

    elements.each(function () {
      i += $(this).width();
    })

    return i
  }

  checkActiveSubmenu() {
    let isActiveSubmenu = !Core.isBpLessThan('md');

    if (!isActiveSubmenu) {
      this.$submenuList.removeAttr('style')
      this.submenuCurrent = 0
      this.$submenuArrowPrev.attr('hidden', true)
      this.$submenuArrowNext.attr('hidden', true)
    }

    return isActiveSubmenu
  }
}
